"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyAction = void 0;
var tslib_1 = require("tslib");
var Action_1 = require("./Action");
var LazyAction = (function (_super) {
    tslib_1.__extends(LazyAction, _super);
    function LazyAction(callback) {
        var _this = _super.call(this) || this;
        _this.callback = callback;
        return _this;
    }
    LazyAction.prototype.execute = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var callbackResult;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        callbackResult = this.callback(data);
                        if (!(callbackResult instanceof Promise)) return [3, 2];
                        return [4, callbackResult];
                    case 1: return [2, _a.sent()];
                    case 2: return [2, callbackResult];
                }
            });
        });
    };
    return LazyAction;
}(Action_1.Action));
exports.LazyAction = LazyAction;
//# sourceMappingURL=LazyAction.js.map